// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__XCRzp","amount":"Amount_amount__ASiUj","tip":"Amount_tip__2BNHd","tipHeader":"Amount_tipHeader__1ixb6","tipsWrap":"Amount_tipsWrap__1eFlR"};